import e from"react";import{AlgoliaSearchServiceContext as r}from"./algolia-search-service-context.js";const o=({children:o,...t})=>e.createElement(r.Provider,{value:t},o);export{o as AlgoliaSearchServiceContextProvider};
